import { merge } from 'lodash'
import {
  RECEIVE_EMAILS,
  ADD_EMAIL_SUCCESS,
  DELETE_EMAIL_SUCCESS,
  MAKE_DEFAULT_SUCCESS
} from '../actions/login-actions'

export default (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_EMAILS:
      return merge({}, {
        email: action.email,
        emails: action.emails
      })
    case ADD_EMAIL_SUCCESS:
      return merge({}, state, {
        emailToAdd: "",
        emails: action.emails
      })
    case DELETE_EMAIL_SUCCESS:
      return merge({}, {
        email: action.email,
        emails: action.emails
      })
    case MAKE_DEFAULT_SUCCESS:
      return merge({}, {
        email: action.email,
        emails: action.emails
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/emails.js